export default {
  "de-DE": {
    "text001": "Stimmen für diesen Helden werden mit {{series_name}} zusammengezählt.",
    "btn001": "Wähle nachSpieltitel",
    "btn002": "Zufalls-auswahl",
    "btn003": "Wähle einen Helden",
    "btn004": "Zufällig",
    "btn005": "Wähle diesen Helden!",
    "share001": "Teile deine Wahl!",
    "btn006": "Deine Heldenliste",
    "text002": "Du hast<br>{{hero_name}} gewählt!",
    "text003": "Für den Zugang zu deiner Heldenliste musst du dich bei deinem Nintendo-Account anmelden. Auf dieser Seite kannst du deine gewählten Helden sehen und besondere Hintergrundbilder erhalten.",
    "text004": "* Du kannst morgen ab 04:00 Uhr CET (3:00 Uhr UTC) erneut wählen."
  },
  "en-GB": {
    "text001": "Votes for this Hero will be tallied with {{series_name}}.",
    "btn001": "Choose byGame Title",
    "btn002": "RandomSelection",
    "btn003": "Choose a Hero",
    "btn004": "Random",
    "btn005": "Choose This Hero",
    "share001": "Share your choice",
    "btn006": "Your Battle Ballot",
    "text002": "You chose {{hero_name}}!",
    "text003": "You must sign in to your Nintendo Account to access your Battle Ballot. You can check which Heroes you've chosen and obtain special wallpaper from this page.",
    "text004": "* You can vote again tomorrow starting at 3:00 a.m. UTC."
  },
  "es-ES": {
    "text001": "Los votos para este personaje se sumarán a los de {{series_name}}.",
    "btn001": "Elegirpor juego",
    "btn002": "Al azar",
    "btn003": "Elegir héroe",
    "btn004": "Al azar",
    "btn005": "¡Elijo este héroe!",
    "share001": "Compartir elección",
    "btn006": "Mi registro",
    "text002": "¡He elegido a<br>{{hero_name}}!",
    "text003": "Debes iniciar sesión con tu cuenta Nintendo para acceder a tu registro. En él podrás comprobar qué héroes has elegido y recibir fondos de pantalla especiales.",
    "text004": "* Podrás votar de nuevo mañana a partir de las 04:00 CET (03:00 UTC)."
  },
  "fr-FR": {
    "text001": "Les votes pour ce héros seront additionnés avec ceux pour {{series_name}}.",
    "btn001": "Choisirun jeu",
    "btn002": "Héros auhasard",
    "btn003": "Choisir un héros",
    "btn004": "Aléat.",
    "btn005": "Voter",
    "share001": "Partager votre vote",
    "btn006": "Votre historique",
    "text002": "J'ai voté pour<br>{{hero_name}} !",
    "text003": "Vous devez vous connecter à votre compte Nintendo pour accéder à votre historique. Vous pouvez y voir les héros pour lesquels vous avez voté et obtenir un fond d'écran spécial.",
    "text004": "* Vous pourrez voter à nouveau dès 04:00 CET (03:00 UTC) demain."
  },
  "it-IT": {
    "text001": "I voti per questo eroe verranno sommati a quelli di {{series_name}}.",
    "btn001": "Selezione pertitolo",
    "btn002": "Selezionecasuale",
    "btn003": "Scegli un eroe",
    "btn004": "Casuale",
    "btn005": "Scegli questo",
    "share001": "Condividi la scelta",
    "btn006": "La tua Lista scelte",
    "text002": "Hai scelto<br>{{hero_name}}!",
    "text003": "Devi usare il tuo account Nintendo per accedere alla tua Lista scelte, dove potrai controllare quali eroi hai scelto e ottenere uno sfondo speciale.",
    "text004": "*Puoi votare di nuovo da domani a partire dalle 04:00 CET (03:00 UTC)."
  },
  "ja-JP": {
    "text001": "この英雄への投票は、{{series_name}}と合算して集計されます。",
    "btn001": "タイトルを選んで投票する",
    "btn002": "ランダムで投票する",
    "btn003": "英雄を選ぶ",
    "btn004": "ランダム",
    "btn005": "投票する",
    "share001": "投票結果をシェア",
    "btn006": "マイページへ",
    "text002": "{{hero_name}}<br>に投票しました！",
    "text003": "マイページを利用するにはニンテンドーアカウントへのログインが必要です。<br> マイページではオリジナル壁紙を獲得したり、投票履歴を確認することができます。",
    "text004": "※明日の12時から再度投票可能です"
  },
  "zh-TW": {
    "text001": "此英雄的得票數將會與{{series_name}}合併計算。",
    "btn001": "選擇遊戲名稱進行投票",
    "btn002": "隨機進行投票",
    "btn003": "選擇英雄",
    "btn004": "隨機",
    "btn005": "進行投票",
    "share001": "分享投票結果",
    "btn006": "前往「My Page」",
    "text002": "您投了{{hero_name}}一票！",
    "text003": "需登入Nintendo Account後才能使用「My Page」功能。<br> 在「My Page」可以獲得原創桌布，並能確認過去的投票紀錄。",
    "text004": "※於隔日12點後可再進行投票"
  },
  "en-US": {
    "text001": "Votes for this Hero will be tallied with {{series_name}}.",
    "btn001": "Choose byGame Title",
    "btn002": "RandomSelection",
    "btn003": "Choose a Hero",
    "btn004": "Random",
    "btn005": "Choose This Hero",
    "share001": "Share your choice",
    "btn006": "Your Battle Ballot",
    "text002": "You chose<br>{{hero_name}}!",
    "text003": "You must sign in to your Nintendo Account to access your Battle Ballot. You can check which Heroes you've chosen and obtain special wallpaper from this page.",
    "text004": "* You can vote again tomorrow starting at 7 p.m. PT."
  },
  "es-MX": {
    "text001": "Los votos para este personaje se sumarán a los de {{series_name}}.",
    "btn001": "Elegirpor juego",
    "btn002": "Al azar",
    "btn003": "Elegir héroe",
    "btn004": "Al azar",
    "btn005": "¡Elijo este héroe!",
    "share001": "Compartir elección",
    "btn006": "Tu boleta",
    "text002": "¡Elegiste a<br>{{hero_name}}!",
    "text003": "Debes iniciar la sesión con tu cuenta Nintendo para acceder a tu boleta. En ella podrás comprobar qué héroes elegiste y recibir fondos de pantalla especiales.",
    "text004": "* Podrás volver a votar mañana a partir de las 19:00 (horario del Pacífico)."
  },
  "fr-CA": {
    "text001": "Les votes pour ce héros seront ajoutés à ceux pour {{series_name}}.",
    "btn001": "Choisirun jeu",
    "btn002": "Héros auhasard",
    "btn003": "Choisir un héros",
    "btn004": "Aléat.",
    "btn005": "Voter",
    "share001": "Partager votre vote",
    "btn006": "Votre historique",
    "text002": "J'ai voté pour<br>{{hero_name}}!",
    "text003": "Vous devez vous connecter à votre compte Nintendo pour accéder à votre historique. Vous pouvez y voir les héros pour lesquels vous avez voté et obtenir un fond d'écran spécial.",
    "text004": "* Vous pourrez voter à nouveau dès 19 h HP demain."
  },
  "pt-BR": {
    "text001": "Votos para este herói serão contados com {{series_name}}.",
    "btn001": "Escolha portítulo de jogo",
    "btn002": "Aleatório",
    "btn003": "Escolha um herói",
    "btn004": "Aleatório",
    "btn005": "Escolher este herói",
    "share001": "Compartilhe a sua escolha",
    "btn006": "Sua cédula",
    "text002": "Você escolheu<br>{{hero_name}}!",
    "text003": "É necessário fazer o login na sua conta Nintendo para acessar o seu histórico. Você pode conferir em quais heróis votou e receber papéis de parede especiais.",
    "text004": "* Você pode votar novamente amanhã a partir das 19h (horário do Pacífico)."
  }
}